import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import PinCodeFieldRow from 'redesign/components/molecules/pin-code-field-row/pin-code-field-row'
import WrongPinWarning from 'redesign/components/molecules/wrong-pin-warning'
import Numpad from 'redesign/components/organisms/numpad'
import { Container, NumpadContainer, TextContainer } from './styles'
import type { PinLoginContentProps } from './types'

const PinLoginContent: React.FC<PinLoginContentProps> = ({ pinState, startTyping, closeSnackbar, isSmallScreen }) => {
  const { t } = useFavurTranslation()
  const { palette } = useTheme()
  const { pinLength, pinValue, attemptsLeft, pinInvalid } = pinState

  return (
    <Container>
      <WrongPinWarning pinState={pinState} closeSnackbar={closeSnackbar} />
      <TextContainer>
        <Typography variant={isSmallScreen ? 'h4' : 'h2'}>{t('component.pinLogin.title')}</Typography>
        <Typography variant={isSmallScreen ? 'body1' : 'h6'} color={palette.text.secondary}>
          {t('component.pinLogin.info')}
        </Typography>
      </TextContainer>
      <NumpadContainer isSmallScreen={isSmallScreen}>
        <PinCodeFieldRow pin={pinValue} pinLength={pinLength} attemptsLeft={attemptsLeft} pinInvalid={pinInvalid} />
        <Numpad numpadType="pinLogin" numpadValue={pinValue} setNumpadValue={startTyping} outputLength={pinLength} />
      </NumpadContainer>
    </Container>
  )
}

export default PinLoginContent
